export function secureMathRandom() {
  return crypto.getRandomValues(new Uint32Array(1))[0]! / 2 ** 32;
}

export function isValidNumber(value: unknown): value is number {
  if (value === undefined || value === null || typeof value !== 'number' || Number.isNaN(value)) {
    return false;
  }
  return true;
}

export function getNumberOrDefault(value: unknown, defaultValue: number): number {
  return isValidNumber(value) ? value : defaultValue;
}

export function getNumberOrNull(value: unknown): number | null {
  return isValidNumber(value) ? value : null;
}

/**
 * Parses a string value into a positive integer. If the value is not a valid positive integer, returns the fallback value.
 * @param value - The value to parse.
 * @param fallback - The fallback value to return if the parsing fails.
 * @returns The parsed positive integer or the fallback value.
 */
export const parsePositiveInteger = (value: unknown, fallback: number): number => {
  if (typeof value !== 'string') {
    return fallback;
  }

  const parsedValue = Number.parseInt(value, 10);

  if (!Number.isFinite(parsedValue) || parsedValue < 1) {
    return fallback;
  }

  return parsedValue;
};
